module.exports = __webpack_public_path__ + "img/right-arrow.993039d3.svg";